import React, {FC} from 'react'
import {TabPanelProps} from '../../../models/models'

const TabPanel: FC<TabPanelProps> = props => {
    const {children, value, index} = props
    return <>{value === index && <>{children}</>}</>
}

export default TabPanel
